import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconTetheringProps } from './IconTethering.types'
import * as Styled from './styles/IconTethering.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTethering: FC<IconTetheringProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTetheringProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconTetheringProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M5.258 18.691a9.501 9.501 0 0 1 .039-13.425c3.715-3.696 9.723-3.688 13.426.023 3.703 3.707 3.703 9.715 0 13.422'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.406 16.594a6.496 6.496 0 0 1-.008-9.188 6.496 6.496 0 0 1 9.188-.015 6.496 6.496 0 0 1 .023 9.187'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M9.527 14.473a3.501 3.501 0 0 1-.015-4.934 3.502 3.502 0 0 1 5.016 4.887' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconTethering
